import {
  faArrowDown,
  faBriefcase,
  faLineChart,
  faPlus,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Card } from 'reactstrap'

import "./styles/style.css"

function JobsManagementHeader() {
  const history = useHistory()
  const { jobs } = useSelector((store) => store.recruitment)
  const activeJobsLength =
    jobs?.filter((job) => job?.status === 'active')?.length || 0
  const inActiveJobsLength =
    jobs?.filter((job) => job?.status === 'inactive')?.length || 0

  return (
    <>
      <Card
        onClick={() => history.push('/job/create')}
        className='bg-info text-white plus-button'
      >
        <FontAwesomeIcon icon={faPlus} className='' />
      </Card>
      <div className='align-items-center job-cards-container'>
        <div className='card p-3 flex-grow-1 d-flex align-items-center justify-content-between flex-row'>
          <div className='d-flex align-items-center' style={{ gap: '0.8rem' }}>
            <div
              className='card px-3 py-3 mb-0'
              style={{ width: 'fit-content' }}
            >
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div>
              <div>Total</div>
              <strong>Jobs</strong>
            </div>
          </div>
          <strong style={{ fontSize: '18px' }}>{jobs?.length}</strong>
        </div>
        <div className='card p-3 flex-grow-1 d-flex align-items-center justify-content-between flex-row'>
          <div className='d-flex align-items-center' style={{ gap: '0.8rem' }}>
            <div
              className='card px-3 py-3 mb-0'
              style={{ width: 'fit-content' }}
            >
              <FontAwesomeIcon icon={faLineChart} />
            </div>
            <div>
              <div>Active</div>
              <strong>Jobs</strong>
            </div>
          </div>
          <strong style={{ fontSize: '18px' }}>{activeJobsLength}</strong>
        </div>

        <div className='card p-3 flex-grow-1 d-flex align-items-center justify-content-between flex-row'>
          <div className='d-flex align-items-center' style={{ gap: '0.8rem' }}>
            <div
              className='card px-3 py-3 mb-0'
              style={{ width: 'fit-content' }}
            >
              <FontAwesomeIcon icon={faArrowDown} />
            </div>
            <div>
              <div>Inactive</div>
              <strong>Jobs</strong>
            </div>
          </div>
          <strong style={{ fontSize: '18px' }}>{inActiveJobsLength}</strong>
        </div>
      </div>
    </>
  )
}

export default JobsManagementHeader
